import { render } from "./ChatBadge.vue?vue&type=template&id=69450cb0"
import script from "./ChatBadge.vue?vue&type=script&lang=js"
export * from "./ChatBadge.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__